module.exports = __webpack_public_path__ + "static/media/chevron.56d4606b.svg";